import React from 'react';
import { s } from './admin.styles';
import { statusDotColor } from './StatusBadge';
import { PromptRecord, ToolRecord } from './admin.types';

interface SidebarItemProps {
  item: PromptRecord | ToolRecord;
  selected: boolean;
  onClick: () => void;
}

export function SidebarItem({ item, selected, onClick }: SidebarItemProps) {
  const dotColor = statusDotColor(item.status);
  const itemStyle = selected ? { ...s.item, ...s.itemSelected } : s.item;
  return (
    <div style={itemStyle} onClick={onClick}>
      <span style={{ ...s.itemDot, background: dotColor }} />
      <div style={s.itemMain}>
        <div style={s.itemName}>{item.name}</div>
        <div style={s.itemDesc}>{item.title}</div>
      </div>
      <div style={s.itemRight}>
        <span style={s.itemVer}>{'v' + item.version}</span>
      </div>
    </div>
  );
}
